import { render, staticRenderFns } from "./ChainSelectInput.vue?vue&type=template&id=80c56710&scoped=true"
import script from "./ChainSelectInput.vue?vue&type=script&lang=js"
export * from "./ChainSelectInput.vue?vue&type=script&lang=js"
import style0 from "./ChainSelectInput.vue?vue&type=style&index=0&id=80c56710&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80c56710",
  null
  
)

export default component.exports